import React from 'react'

import { contentService } from '../../../common/services/content.service'
import { usePageEditorContext } from '../../contexts/page-editor.context'
import { EmptyBlock } from '../empty-block'

import { useStyles } from './image-block.style'

export const ImageBlock = function ({ blockKey, report, imageVersion, extension, source, label, width = '100%' }) {
  const classes = useStyles()

  const pageEditorContext = usePageEditorContext()

  let containerId = report.parent.dataContainerId
  let path = imageVersion
    ? `images/${blockKey}/${imageVersion}.${extension}`
    : undefined

  // Remove this & source prop when we've moved all images to the data container
  if (source) {
    containerId = report.containerId
    path = source
  }

  // TODO: We should move this logic into something editor specific instead of depending on page editor context from
  // this non-editor specific component.
  if (pageEditorContext && path === undefined) {
    return (
      <EmptyBlock>Empty Image Block</EmptyBlock>
    )
  }

  return (
    <>
    { label && <div className={classes.label}>{label}</div> }
    { path && <img className={classes.image} src={contentService.getUrl(containerId, path)} style={{ width }} /> }
    </>
  )
}
